import { defineStore } from 'pinia';
import { SystemApi } from '@/modules/core/api/system.api.ts';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import { DBType } from '@/modules/common/enums/db-type.ts';

interface State {
  dbType: DBType | null;
  storageUrl: string | null;
  isAutoSignEnabled: boolean | null;
}

/* Синхронизируется между вкладками */
export const useSyncSystemStore = defineStore(StoreId.SyncSystem, {
  state: (): State => ({
    dbType: null,
    storageUrl: null,
    isAutoSignEnabled: null,
  }),
  actions: {
    setDBType(dbType: DBType) {
      this.dbType = dbType;
    },
    setStorage(storageUrl: string) {
      this.storageUrl = storageUrl;
    },
    async fetchAutoSignEnabled() {
      this.isAutoSignEnabled = await SystemApi.getAutoSignEnabled();
    },
  },
  persist: true,
});
